/* eslint-disable max-depth */
import { v4 as uuid } from 'uuid';
import iframeOrExtPostMessage, {
  iframeOrExtExists
} from '../shared/utils/iframeOrExtPostMessage';

export default (...args) => {
  const token = uuid().toString();

  if (iframeOrExtExists()) {
    return new Promise((resolve, reject) => {
      const listener = response => {
        try {
          if (response.data) {
            const { data } = response;
            const { payload } = data;

            if (
              data.EVENT_NAME === 'PROXY_FETCH_RESPONSE' &&
              payload.token === token
            ) {
              // You can't send the 'response' from a fetch over postmessage because it contains things
              // that can't be cloned (https://stackoverflow.com/questions/52122011/failed-to-execute-postmessage-on-window-googletagmanager)
              // So we send the response manually as permitted types and rebuild it
              if (response.data.payload.fetchResponseProps.status === 204) {
                resolve(new Response(null, { status: 204 }));
              } else if (payload.fetchResponseBlob) {
                const proxiedResponse = new Response(
                  payload.fetchResponseBlob.stream(),
                  payload.fetchResponseProps
                );

                resolve(proxiedResponse);
              } else if (payload.fetchError) {
                reject(payload.fetchError);
              } else {
                reject('Need to handle this');
              }

              window.removeEventListener('message', listener);
            }
          }
        } catch (error) {
          console.log(error);
        }
      };

      window.addEventListener('message', listener);

      iframeOrExtPostMessage(
        { EVENT_NAME: 'PROXY_FETCH', payload: { fetch: args, token } },
        '*'
      );
    });
  } else {
    // dont proxy
    return window.fetch(...args);
  }
};
